<script setup lang="ts">
type Props = {
  /** Secondary metadata line. Omit and use the default slot for rich content. */
  text?: string;
};

defineProps<Props>();
</script>

<template>
  <p class="text-caption w-full text-on-surface-secondary">
    <slot>{{ text }}</slot>
  </p>
</template>
